import { isValidKegCode, normalizeKegCode } from './kegCode';

/** Statuses that mean the keg holds no beer (product + batch are cleared). */
export function isKegProductClearedStatus(status: string | null | undefined): boolean {
  return /^(empty|destroyed|broken)$/i.test(String(status || '').trim());
}

/**
 * Keg tag to carry into Manual Update: the "Enter keg tag" box first, then the
 * "Search tag" filter. Only a full valid tag (e.g. EK08495) is used.
 */
export function manualUpdatePrefillCode(...candidates: Array<string | null | undefined>): string {
  for (const raw of candidates) {
    const code = normalizeKegCode(String(raw || ''));
    if (code && isValidKegCode(code)) return code;
  }
  return '';
}
